import styled from "styled-components";
import parseDate from "../../../../controllers/parseDate";
import parseDropDownValue from "../../../../controllers/utils/parseDropDownValue";
import contractTypesForSite from "../../../../data/employee/contractTypesForSite";
import { useContext } from "react";
import Context from "../../../../Context";
import assistanceTypes from "../../../../data/employee/assistanceTypes";
import CustomLabel from "../../../customUiForCs/CustomLabel";
import BubbleTextForDetailData from "../../../customUiForCs/BubbleTextForDetailData";

const BubbleText = styled.div`
  padding: 10px 15px;
  background-color: var(--surface);
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  /* flex: 2; */

  color: var(--element);
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
`;

const Container = styled.div`
  padding: 25px;
  background-color: var(--surface3);
  border: 1px solid var(--borderDim);
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 50%;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

const SubList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;

//  image: item.image,
//       clientName: item.clientName,
//       placeName: item.placeName,
//       zoneID: item.zoneID,
//       longitude: item.longitude,
//       latitude: item.latitude,
//       contacts: item.contacts,

//       dateOfImplementation: item.dateOfImplementation,
//       contracts: item.contracts,
//       assistance: item.assistance,

//       addressLocality: item.addressLocality,
//       addressStreet: item.addressStreet,
//       directionToFollow: item.directionToFollow,
//       specialInstructions: item.specialInstructions,

export default function SiteDetailSection({ item }) {
  const { employeeFunctions } = useContext(Context);
  const functionOptions = employeeFunctions?.length
    ? employeeFunctions
    : contractTypesForSite;

  return (
    <Container>
      <SubSection>
        <CustomLabel>Details</CustomLabel>
        <SubList>
          {/* <BubbleTextForDetailData>
            Nom de code : {item.codename || "Non"}
          </BubbleTextForDetailData> */}
          <BubbleTextForDetailData>
            Nom du client : {item.clientName || "Non"}
          </BubbleTextForDetailData>
        </SubList>
        <SubList>
          <BubbleTextForDetailData>
            Longitude : {item.longitude || "Non"}
          </BubbleTextForDetailData>
          <BubbleTextForDetailData>
            Latitude : {item.latitude || "Non"}
          </BubbleTextForDetailData>

          <BubbleTextForDetailData>
            Date de mise en place : {parseDate(item.dateOfImplementation)}
          </BubbleTextForDetailData>

          {item.contractEndDate && (
            <BubbleTextForDetailData>
              Date de fin : {parseDate(item.contractEndDate)}
            </BubbleTextForDetailData>
          )}
        </SubList>
      </SubSection>

      <SubSection>
        <CustomLabel>Contacts</CustomLabel>
        <SubList>
          {!item.contacts || !item?.contacts?.length ? (
            <BubbleTextForDetailData>Non</BubbleTextForDetailData>
          ) : null}

          {item.contacts
            ? item.contacts.map((item) => (
                <BubbleTextForDetailData>
                  {item.clientName} ({item.designation}) : {item.phoneNumber}
                </BubbleTextForDetailData>
              ))
            : null}
        </SubList>
      </SubSection>

      <SubSection>
        <CustomLabel>Emplacement</CustomLabel>
        <SubList>
          <BubbleTextForDetailData>
            {item.zoneName ? item.zoneName : "Zone : Non"}
          </BubbleTextForDetailData>
          <BubbleTextForDetailData>
            Commune:{item.addressLocality || "Non"}
          </BubbleTextForDetailData>

          <BubbleTextForDetailData>
            Rue : {item.addressStreet || "Non"}
          </BubbleTextForDetailData>
        </SubList>

        <SubList>
          <BubbleTextForDetailData>
            Directions à suivre : {item.directionToFollow || "Non"}
          </BubbleTextForDetailData>
        </SubList>
      </SubSection>

      <SubSection>
        <CustomLabel>Contrats</CustomLabel>

        <SubList>
          {!item.contracts || !item?.contracts?.length ? (
            <BubbleTextForDetailData>Non</BubbleTextForDetailData>
          ) : null}

          {item.contracts
            ? item.contracts.map((item) => (
                <BubbleTextForDetailData>
                  {parseDropDownValue({
                    query: item.type,
                    theArray: functionOptions,
                  })}{" "}
                  :jour {item.dayShift} , nuit {item.nightShift}
                </BubbleTextForDetailData>
              ))
            : null}

          {item.holidayStaff && item.holidayStaff.length
            ? item.holidayStaff.map((item) => (
                <BubbleTextForDetailData>
                  {parseDropDownValue({
                    query: item.type,
                    theArray: functionOptions,
                  })}{" "}
                  (Holiday/Weekend) : jour {item.dayShift} , nuit{" "}
                  {item.nightShift}
                </BubbleTextForDetailData>
              ))
            : null}
        </SubList>
      </SubSection>

      <SubSection>
        <CustomLabel>Assistance</CustomLabel>
        <SubList>
          {!item.assistance || !item?.assistance?.length ? (
            <BubbleTextForDetailData>Non</BubbleTextForDetailData>
          ) : null}

          {item.assistance
            ? item.assistance.map((item) => (
                <BubbleTextForDetailData>
                  {parseDropDownValue({
                    query: item.type,
                    theArray: assistanceTypes,
                  })}
                  : ({item.count})
                </BubbleTextForDetailData>
              ))
            : null}
        </SubList>
      </SubSection>

      <SubSection>
        <CustomLabel>Instructions spéciales</CustomLabel>
        <SubList>
          <BubbleTextForDetailData>
            Description:{item.specialInstructions || "Non"}
          </BubbleTextForDetailData>
        </SubList>
      </SubSection>
    </Container>
  );
}
